import { Box, Button, Typography } from "@mui/material";
import { ContextualContentBox, FoodsIcon, IconMapping } from "@foodpilot/foods";
import { useTheme } from "@mui/material/styles";

type ActionPlanEmptyStateProps = {
    icon: keyof IconMapping;
    title: string;
    cta?: { url?: string; label: string };
    disabled?: boolean;
};

const ActionPlanEmptyState = (props: ActionPlanEmptyStateProps) => {
    const { icon, title, cta, disabled } = props;
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: "grid",
                width: "100%",
                height: "100%",
                maxWidth: "300px",
                "& > .MuiBox-root": {
                    p: 0,
                    pt: theme.spacing(4),
                    boxShadow: "none",
                    border: "none",
                    display: "flex",
                    width: "100%",
                    height: "100%",
                    "& .MuiStack-root": {
                        borderRadius: 4,
                        display: "block",
                        height: "100%",
                        width: "100%",
                    },
                },
            }}
        >
            <ContextualContentBox>
                <Box
                    sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        gap: theme.spacing(3),
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: theme.spacing(1.5),
                            borderRadius: "100%",

                            backgroundColor: theme.palette.common.white,
                        }}
                    >
                        <FoodsIcon icon={icon} size={2} />
                    </Box>
                    <Box
                        gap={2}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                            height: "100%",
                        }}
                    >
                        <Box>
                            <Typography variant="h3" align="center">
                                {title}
                            </Typography>
                        </Box>
                    </Box>
                    <Button
                        href={cta?.url}
                        variant="primary"
                        fullWidth
                        sx={{ p: theme.spacing(2, 1) }}
                        disabled={disabled}
                    >
                        <Typography variant="body2" fontWeight={theme.typography.fontWeightMedium}>
                            {cta?.label}
                        </Typography>
                    </Button>
                </Box>
            </ContextualContentBox>
        </Box>
    );
};

export default ActionPlanEmptyState;
